if (!window.customElements.get('pdp-reviews')) {

  class PdpReviews extends HTMLElement {
    constructor() {
      super();
      this.currentHeight = 0;
      this.resizeListenerId = null;
      this.observer = null;
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.cleanup();
    }

    init() {
      // Get the resize manager (available globally)
      if (!window.resizeManager) {
        console.warn('SectionHeightCalculator: ResizeManager not available');
        return;
      }

      // Calculate initial height
      this.calculateHeight();

      // Add resize listener
      this.resizeListenerId = `section-height-${this.generateId()}`;
      window.resizeManager.addListener(this.resizeListenerId, this.handleResize.bind(this));

      // Check and hide section if empty review is present
      this.checkAndHideSection();

      // Set up mutation observer to watch for content changes
      this.setupMutationObserver();

      // Dispatch initial height event
      this.dispatchHeightEvent();

      document.addEventListener("sectionHeightChanged", (e) => {
        // Footer refresh no longer needed - only newsletter bounce functionality remains        
        // waitForEl(".junip-recommendation-text", () => { 
        //   document.querySelectorAll(".junip-recommendation-text").forEach(text => {
        //     text.textContent = "I recommend";
        //   });
        // });
      });
    }

    // Hide parent section if .junip-product-review-empty is present
    checkAndHideSection() {
      var emptyReview = this.querySelector('.shopify-block.shopify-app-block .junip-product-review-empty');
      if (emptyReview) {
        var section = this.closest('.shopify-section');
        if (section) {
          // @review - check better way to hide section without flicker
          section.style.display = 'none';
          this.cleanup();
        }
      }
    }

    cleanup() {
      // Remove resize listener
      if (window.resizeManager && this.resizeListenerId) {
        window.resizeManager.removeListener(this.resizeListenerId);
      }

      // Disconnect mutation observer
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    setupMutationObserver() {
      // Watch for changes in the element's content
        this.observer = new MutationObserver(() => {
          this.calculateHeight();
          this.dispatchHeightEvent();
          this.checkAndHideSection();
        });

        // Start observing
        this.observer.observe(this, {
          childList: true,
          subtree: true,
          attributes: true
        });
    }

    handleResize(resizeData) {
      // Recalculate on any resize
      this.calculateHeight();
      this.dispatchHeightEvent();
    }

    calculateHeight() {
      // Get the computed height of the element
      const rect = this.getBoundingClientRect();
      const computedStyle = window.getComputedStyle(this);
      
      // Calculate total height including margins
      const marginTop = parseFloat(computedStyle.marginTop) || 0;
      const marginBottom = parseFloat(computedStyle.marginBottom) || 0;
      const totalHeight = rect.height + marginTop + marginBottom;

      this.currentHeight = Math.round(totalHeight);
      
      // Set CSS custom property for easy access in CSS
      this.style.setProperty('--section-height', `${this.currentHeight}px`);
      
      return this.currentHeight;
    }

    dispatchHeightEvent() {
      // Dispatch custom event with height data
      const event = new CustomEvent('sectionHeightChanged', {
        detail: {
          height: this.currentHeight,
          element: this,
          timestamp: Date.now()
        },
        bubbles: true
      });
      
      this.dispatchEvent(event);
    }

    // Get current height
    getHeight() {
      return this.currentHeight;
    }

    // Force recalculation
    recalculate() {
      this.calculateHeight();
      this.dispatchHeightEvent();
      return this.currentHeight;
    }

    // Generate unique ID for resize listener
    generateId() {
      return Math.random().toString(36).substr(2, 9);
    }
  }

  // Register the custom element
  customElements.define('pdp-reviews', PdpReviews);

}